const formatDate = {}

import { format } from 'date-fns';

formatDate.install = function (Vue) {
  /*
  * Valida el tipo de campo y lo formatea según sus características
  */
  Vue.filter('formatDate', (date) => {
    return format(new Date(date), "yyyy-MM-dd")
  })
}

export default formatDate



// WEBPACK FOOTER //
// ./src/utils/filters/formatDate.js